import React from 'react';

import Tabs, { TabsProps, TabPaneProps } from 'antd/es/tabs';

import { useMobileView } from '@common/react/hooks/useMobileView';

interface AppointmentFiltersTabsProps extends Omit<TabsProps, 'items'> {
	items: Array<Omit<TabPaneProps, 'children'> & {
		visible: boolean;
		key: string;
		onBadgeClick: () => void;
		label: React.ReactNode;
		count?: number;
	}>;
}

const AppointmentFiltersTabs: React.FC<AppointmentFiltersTabsProps> = (props) => {
	const isMobile = useMobileView(768);
	const enableItems = props.items
		.filter((item) => item.visible === undefined || item.visible);
	const [tab, selectTab] = React.useState<string>(enableItems[0].key);
	const solveItems = props.items
		.filter((item) => item.visible === undefined || item.visible)
		.map((item) => {
			const onClick = () => {
				if (tab !== item.key && isMobile) {
					return;
				}
				item.onBadgeClick();
			};

			return {
				...item,
				label: <>
					{item.label}
					&nbsp;
					{item.count !== undefined && item.count > 0
						&& <div
							onClick={onClick}
							className="badge dashboard-container-user-block__badge"
						>
							<span>
								{' '}
								{item.count}
							</span>
							<i className="fa fa-times" />
						</div>}
				</>,
			};
		});
	return <Tabs
		{...props}
		items={solveItems}
		activeKey={tab}
		onChange={selectTab}
	/>;
};

export default AppointmentFiltersTabs;
